module.exports = function() {
  return new Worker(__webpack_public_path__ + "e41e35c6921506155f9d.worker.js");
};